import React from 'react'
import Logo from '../../components/Logo/logo';
import loginVector from '../../assets/images/login_signup_left_vector.svg';
import './login.scss';
// import SolidButton from '../../components/Buttons/solidButton/solidButton';
import SimpleSlider from '../../components/Slider/Slider';
import LoginForm from './LogInForm/logInForm';
import { Link } from 'react-router-dom';

function Login() {
    return (
        <div className='login-page'>
            <div className='login-col login-left-container'>
                <img className='login-vector' src={loginVector} alt="" />
                <SimpleSlider />
            </div>
            <div className='login-col login-right-container'>
                <Logo />
                <h1>Welcome Back!</h1>
                <p>Sign in and start generating responses!</p>
                {/* <form className='login-form'>
                <SolidButton />
                </form> */}
                <LoginForm />
                <p className='sign-up'>Don’t have an account? <Link to='/sign-up'>Sign up for free</Link></p>
            </div>
        </div>
    )
}

export default Login
